import { LOADED } from '@peoplenet/vi-components-ui/src/app/user/UserActionsType';
import service from './SecurityService';
import {
  SECURITY_REQUEST,
  SECURITY_FAILURE,
  SECURITY_SUCCESS,
} from './SecurityActionType';
import { setupTranslation } from '../app/translation';

export const getInfo = () => async (dispatch) => {
  dispatch({ type: SECURITY_REQUEST });

  try {
    const userInfo = await service.get();
    setupTranslation(userInfo.language);
    dispatch({
      type: SECURITY_SUCCESS,
      payload: {
        userInfo,
      },
    });
    dispatch({
      type: LOADED,
      payload: {
        ...userInfo,
      },
    });
  } catch (e) {
    dispatch({ type: SECURITY_FAILURE });
  }
};
